import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      padding: [30, 0],
      textAlign: "center",
      fontSize: theme.typography.pxToRem(9),
      lineHeight: theme.typography.pxToRem(13),
      color: theme.palette.portGore,
      "& a": {
        textDecoration: "underline",
        fontWeight: 800,
      },
      [theme.breakpoints.up("mobile")]: {
        width: 350,
        margin: [0, "auto"],
        lineHeight: theme.typography.pxToRem(11),
      },
      [theme.breakpoints.up("tablet")]: {
        width: 350,
        lineHeight: theme.typography.pxToRem(15),
      },
    },
  }),
  { name: "PurchaseDisclaimer" },
);
